// @ts-nocheck
import genRequest from "includes/request";

// categories/post/:id answers junction rows [{ postId, categoryId, category }].
// Flatten once at the entry so tiles, tags and the category filter all read
// the plain category (id, categoryName, categoryColor, description...).
export const fetchPostCategories = (postId) =>
	genRequest("categories/post/" + postId).then((rows) =>
		(rows ?? []).map((row) => ({ ...row.category, categoryId: row.categoryId }))
	);
